export default __webpack_public_path__ + "static/media/amt-person.f86bebfa.png";